import CordovaContactImporter from '@powerednow/shared/modules/importer/contact/cordovaContactImporter';

declare let DataWrapper: any;

export default class ExtCordovaContactImporter extends CordovaContactImporter {
    protected async buildNewCustomer() {
        return DataWrapper.createComplexDataObject('Customer', {});
    }
}
